import React, { useEffect, useState } from 'react';

// import { Link } from 'react-router-dom';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

// import axios from "../axios-afterschoolmusic";

// import DesktopMenu from '../common/components/Navigation/DesktopMenu.js';

import Header from '../common/components/Header.js';
import Footer from '../common/components/Footer.js';
import { URL_ROOT } from '../common/globalConstants.js';
import { getTextBlocks } from '../common/globalMethods.js';

const PrivacyPolicy = (props) => {

	const {
		allTextBlocks,
		description,
		history,
		locationId,
		textBlocks,
		title
	} = props;

	const [pageTextBlocks, setPageTextBlocks] = useState([]);

	function listTextBlocks(currentPageTextBlocks, siteTextBlocks) {
		if(currentPageTextBlocks) {
			const currentTextBlocks = [];
			let matchingTextBlock = [];
			if(!Array.isArray(textBlocks)) {
				// eslint-disable-next-line
				matchingTextBlock = siteTextBlocks.filter(x => x.id == currentPageTextBlocks.TextBlockId);
				if(matchingTextBlock && matchingTextBlock.length === 1) {
					currentTextBlocks.push(matchingTextBlock[0]);
				}
			} else {
				const sortedTextBlocks = currentPageTextBlocks.sort((a, b) => (a.Order > b.Order) ? 1 : -1);

				for(let i = 0; i < sortedTextBlocks.length; i++) {
					// eslint-disable-next-line
					matchingTextBlock = siteTextBlocks.filter(x => x.id == sortedTextBlocks[i].TextBlockId);
					if(matchingTextBlock && matchingTextBlock.length === 1) {
						currentTextBlocks.push(matchingTextBlock[0]);
					}
				}
			}

			setPageTextBlocks(currentTextBlocks);
		}
	}

	useEffect(() => {
		if(allTextBlocks && allTextBlocks.length > 0) {
			listTextBlocks(textBlocks, allTextBlocks);
		} else if(textBlocks != null) {
			getTextBlocks()
			.then(response => {
				listTextBlocks(textBlocks, response);
			}).catch(error => {
				console.warn("Error", error);
			});
		} else {
			history.push(URL_ROOT);
		}
	// eslint-disable-next-line
	}, []);

	return (
		<React.Fragment>
		<MetaTags>
		<title>{title}</title>
		<meta name="description" content={description} />
		<meta property="og:title" content={title} />
		</MetaTags>
		<Header locationId={locationId} />
		<main>
		<div className='content'>
		<div className='pageContent'>
		{pageTextBlocks.map(pageTextBlock => {
			if(pageTextBlock.IsHtml) {
				return <div key={pageTextBlock.id} className='bodyHtml' dangerouslySetInnerHTML={{__html: pageTextBlock.BodyText}} />;
			} else {
				return <p key={pageTextBlock.id} className='bodyText'>{pageTextBlock.BodyText}</p>;
			}
		})}
		</div>
		</div>
		</main>
		<Footer locationId={locationId} />
		</React.Fragment>
	);
};

const mapStateToProps = state => {
	return {
		allTextBlocks: state.application.textBlocks
	};
};

export default withRouter(connect(mapStateToProps, null)(PrivacyPolicy));
